var React = require('react');

function ChevronBlueFaq (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.799805 1L11.9998 9L23.1998 1","stroke":"#2B40C7","strokeWidth":"1.6","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ChevronBlueFaq.defaultProps = {"width":"24","height":"10","viewBox":"0 0 24 10","fill":"none"};

module.exports = ChevronBlueFaq;

ChevronBlueFaq.default = ChevronBlueFaq;
